module.exports = __webpack_public_path__ + "img/acpv_on_grid.3445b127.png";